import { observable } from "mobx";
import { GET } from "lib/api";
import config from "lib/config";
import _ from "lodash";

const courseId = config.courseId;
const profileId = config.profileId;
const fromProfileId = config.fromProfileId;

class NavigationTreeStore {
  @observable expanded = false;
  @observable active = undefined;
  @observable ready = false;
  @observable nodes = [];

  constructor() {}

  async reload(opts) {
    let force = !!(opts && opts.force);
    if (!force && this.ready) return;

    if (!config.isLoggedIn) {
      this.ready = true;
      this.nodes = [];
      this.courses = [];
      return;
    }

    let nodes = await GET(
      `/v1/courses/:courseId/content/navtree?${new URLSearchParams({
        profileId,
        fromProfileId: fromProfileId ? fromProfileId : 0,
      })}`,
      { courseId },
    );

    this.nodes = nodes;
    this.isAdmin = await GET("/v1/user/isadminorteacherincourse/:courseId", {
      courseId,
    });
    this.studentView = fromProfileId || false;
    this.ready = true;
  }

  async getNodes(callback) {
    let nodes = await GET(
      `/v1/courses/:courseId/content/navtree?${new URLSearchParams({
        profileId,
        fromProfileId: fromProfileId ? fromProfileId : 0,
      })}`,
      {
        courseId,
      },
    );

    callback(nodes);
  }

  reloadNodes(nodes) {
    this.nodes = nodes;
  }

  toggleNode(e) {
    let nodeID = e.currentTarget.parentElement.id;
    let tempNodes = this.nodes.slice();

    let node = tempNodes.find(function (e) {
      return e.navTreeID == nodeID;
    });
    node.expanded = !node.expanded;
    this.nodes = tempNodes;

    e.currentTarget.parentElement
      .querySelector("ul")
      .classList.toggle("contracted");
  }

  setSelectedNode(navTreeId) {
    let tempNodes = this.nodes.slice();
    let node = tempNodes.find((e) => {
      return e.navTreeID === navTreeId;
    });
    let prevActive = tempNodes.find((e) => {
      return e.active == true;
    });
    if (prevActive) {
      prevActive.active = false;
    }

    this.updateUrl(navTreeId);

    //Deselect active item in function menu
    eduutils.DeselectCourseMenu();

    if (node) {
      node.active = true;
      this.expandToNode(tempNodes, node);
    }

    this.nodes = tempNodes;

    //Close menu if in mobile
    if ($("[id*='mobilefooter']").is(":visible")) {
      //Only toggle if open
      if ($(".course.menu").hasClass("selected")) {
        eduutils.ToggleCourseMenu();
      }
    } else {
      //Close menu,when changing page if there is not enough room
      if ($(window).width() < eduutils.toggleMenuBreakPoint) {
        eduutils.ToggleCourseMenu();
      }
    }
  }

  updateUrl(navTreeId) {
    let stateObj = {
      navtreeid: "navtreeid",
    };
    let newUrl;
    let doUpdate = true;

    //replace navtreeid in url
    if (location.href.indexOf("navtreeid") != -1) {
      let oldNavTreeId = luvit.GetQueryString("navtreeid");

      if (oldNavTreeId == navTreeId) doUpdate = false;
      else
        newUrl = luvit.updateURLParameter(
          location.href,
          "navtreeid",
          navTreeId,
        );
    } else {
      newUrl = document.location.href + "&navtreeid=" + navTreeId;
    }

    if (doUpdate) history.replaceState(stateObj, "", newUrl);
  }

  expandToNode(tempNodes, node) {
    if (node.parent && node.parent != "0") {
      let parentNode = tempNodes.find((e) => {
        return e.navTreeID === node.parent;
      });
      parentNode.expanded = true;

      if (parentNode.parent) {
        this.expandToNode(tempNodes, parentNode);
      }
    }
  }

  findFirstContentNode(nodes) {
    if (!nodes) {
      nodes = _.filter(this.nodes, function (n) {
        return n.parent == "0";
      });
    }

    let firstContentNode;

    //Remove home node
    if (nodes[0] && nodes[0].typeID == 0) {
      nodes.shift();
    }

    //om första noden är ett dokument
    if (nodes[0] && nodes[0].typeID > 1) {
      firstContentNode = nodes[0];
    } else {
      // return
    }

    //let firstContentNode = this.nodes.find((n) => {return n.typeID > 1 })

    if (firstContentNode) return firstContentNode.navTreeID;
    else {
      for (var i = 0, len = nodes.length; i < len; i++) {
        let childNodes = nodes[i].childNodes;

        if (childNodes && childNodes.length > 0)
          return this.findFirstContentNode(childNodes);
      }
    }
  }

  getActive() {
    let node = this.nodes.find((n) => {
      return n.active;
    });

    if (node) return node.navTreeID;
  }

  isBookmarked(navTreeId) {
    let node = this.nodes.find((n) => {
      return n.navTreeID == navTreeId;
    });
    return node.isBookMarked;
  }

  resetTree(keepState) {
    let tempNodes = this.nodes.slice();

    for (let i = 0, len = tempNodes.length; i < len; i++) {
      if (!keepState) {
        tempNodes[i].expanded = false;
      }
      tempNodes[i].active = false;
    }

    this.nodes = tempNodes;
  }

  containsNode(navTreeId) {
    let node = this.nodes.find((n) => {
      return n.navTreeID == navTreeId;
    });

    if (node) {
      return true;
    }

    return false;
  }

  expandAll() {
    let tempNodes = this.nodes.slice();

    _.forEach(tempNodes, (n) => {
      n.expanded = true;
    });

    this.nodes = tempNodes;
  }

  collapseAll() {
    let tempNodes = this.nodes.slice();

    _.forEach(tempNodes, (n) => {
      n.expanded = false;
    });

    this.nodes = tempNodes;
  }
}

export default new NavigationTreeStore();
